import type { Build, PlatformBuild } from '@todesktop/shared';

const PLATFORMS = ['linux', 'mac', 'windows'] as const;

export function hasBuildKickedOff(build: Build | null | undefined): boolean {
  return Boolean(build?.status && build.status !== 'preparation');
}

// NOTE: this relies on Firestore solely
export function isBuildCancellable(build: Build | null | undefined): boolean {
  return hasBuildKickedOff(build) && isBuildRunning(build);
}

export function isBuildRunning(build: Build | null | undefined): boolean {
  if (!build) {
    return false;
  }
  return (
    !['cancelled', 'succeeded'].includes(build.status) &&
    PLATFORMS.some((platform) => isPlatformBuildRunning(build[platform]))
  );
}

export function isPlatformBuildRunning(
  platformBuild: PlatformBuild | null | undefined,
): boolean {
  if (!platformBuild) {
    return false;
  }
  return (
    !platformBuild.shouldSkip && // <-- Noteworthy
    !['cancelled', 'succeeded'].includes(platformBuild.status) &&
    ('failed' !== platformBuild.status ||
      platformBuild.numberOfAttemptedBuilds < 2)
  );
}
